import notify from 'devextreme/ui/notify';
import { formatApiError } from './errors';

export type NotifyType = 'success' | 'info' | 'warning' | 'error';

export function showToast(message: string, type: NotifyType = 'info', displayTime = 4000): void {
  notify({ message, type, displayTime, position: { my: 'top right', at: 'top right', offset: '-20 20' } }, type, displayTime);
}

export function showError(err: unknown, fallback = 'Произошла ошибка'): void {
  const msg = formatApiError(err) || fallback;
  showToast(msg, 'error', 6000);
}

export function showSuccess(msg: string): void {
  showToast(msg, 'success', 2500);
}
